import { FormControlLabel, CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import { getToken } from 'client/modules/Auth/AuthReducer';
import { setEmailPreferences } from 'client/modules/EmailPreferences/EmailPreferencesActions';
import { getUnsubscribes } from 'client/modules/EmailPreferences/EmailPreferencesReducer';
import React from 'react';
import Helmet from 'react-helmet';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const messages = defineMessages({
  title: {
    id: 'EmailPreferences.Title',
    defaultMessage: 'Email Preferences',
  },
  system: {
    id: 'EmailPreferences.System',
    defaultMessage: 'System messages (such as password reminders)',
  },
  features: {
    id: 'EmailPreferences.Features',
    defaultMessage: 'Promoter Ninja features and services communications',
  },
});

// Define the available preference types
const PREFERENCE_TYPES = ['features'];

const EmailPreferencesPageContent = () => {
  const dispatch = useDispatch();
  const unsubscribes = useSelector(getUnsubscribes);
  const token = useSelector(getToken);
  const { formatMessage } = useIntl();

  // Check if data is still loading (values are undefined)
  const isLoading = unsubscribes && Object.values(unsubscribes).some(value => value === undefined);

  const getErrorMessage = (err) => {
    const key = err ? err.message : null;
    const defaultErr = (
      <FormattedMessage
        id="EmailPreferences.Errors.Unknown"
        defaultMessage="An unknown error occurred while saving email preferences."
      />
    );
    switch (key) {
      default:
        return defaultErr;
    }
  };

  const handleToggle = (group, event) => {
    dispatch(setEmailPreferences(token, group, null, null, group, !event.target.checked, getErrorMessage));
  };

  return (
    <Paper style={{ padding: '2em' }}>
      <Helmet title={formatMessage(messages.title)} />
      <p>
        <FormattedMessage
          id="EmailPreferences.WhichCommunications"
          defaultMessage="Which communications do you want to receive?"
        />
      </p>
      
      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem 0' }}>
          <CircularProgress size={20} />
          <span>Loading preferences...</span>
        </div>
      ) : (
        PREFERENCE_TYPES.map(key => (
          messages[key] ? (
            <div key={key} style={{ marginBottom: '1rem' }}>
              <FormControlLabel
                control={(
                  <Switch
                    color="primary"
                    checked={!unsubscribes[key]}
                    onChange={handleToggle.bind(this, key)}
                  />
                )}
                label={formatMessage(messages[key])}
                labelPlacement="start"
              />
            </div>
          ) : null
        ))
      )}
    </Paper>
  );
};

export default EmailPreferencesPageContent; 